module.exports = __webpack_public_path__ + "img/l-hd.c361c6ed.webp";